
import { Component, NgModule, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Chart } from 'chart.js';
import { AttendanceService } from 'src/app/shared/services/attendanceservices/attendance.service';
import { FormsModule, NgForm } from '@angular/forms';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { LeaveService } from 'src/app/shared/services/leaveservices/leave.service';
import { DatePipe } from '@angular/common';
import { Location } from '@angular/common';
import moment from 'moment';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { calculateUpdatedTime } from 'src/app/attendance/shift-time';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { DeviceUuidService } from 'src/app/shared/services/deviceuuidservices/device-uuid.service';
import { environment } from 'src/environments/environment';
import { OneSignal } from 'onesignal-ngx';
import { ApexNonAxisChartSeries, ApexPlotOptions, ApexChart, ApexFill, ChartComponent, ApexAxisChartSeries, ApexDataLabels, ApexYAxis, ApexXAxis, ApexTooltip, ApexStroke, ApexLegend, ApexTitleSubtitle, } from "ng-apexcharts";
import { NgApexchartsModule } from 'ng-apexcharts';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { HttpClient } from '@angular/common/http';
import { UserAttendanceTypeComponent } from './user-attendance-type/user-attendance-type.component';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';

interface DataPoint {
  date: string;
  values: number[]; // Array for four series
}

@Component({
  selector: 'app-user-attendance',
  templateUrl: './user-attendance.component.html',
  styleUrl: './user-attendance.component.css',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, LoaderComponent, UserAttendanceTypeComponent, NgApexchartsModule],
  providers: [DatePipe],
})
export class UserAttendanceComponent implements OnInit {
  // @NgModule({
  //   imports: [
  //     NgApexchartsModule,
  //   ],
  // })
  @ViewChild("chart") chart!: ChartComponent;
  @ViewChild("pieChart") pieChart!: ChartComponent;
  // public chartOptions: any;
  public chartOptions: any = {
    series: [],
    chart: { type: 'bar' },   // or your desired type
    plotOptions: {},
    dataLabels: { enabled: false },
    grid: {},
    colors: []
  };
  public optionsProgress3: any;
  public pieChartOptions: any;
  private allData: DataPoint[] = [];
  private categories: string[] = [];

  typeArr: any = [];
  public overtime: any = '';
  public workingHours: any = '';
  public stats: any = [];
  public checkInStatus: any = '';
  public checkStats = false;
  public checkInTime: any = '';
  public user: any = [];
  public leaves: any[] = [];
  public paidLeaves: any[] = [];
  public unpaidLeaves: any[] = [];
  public pendingLeaves: any[] = [];
  public shortLeaves: any[] = [];
  public actionattendance: any[] = [];
  public showSpinner = true;
  public startdate: string | null;
  public endDate: string | null;
  public filterType = "";
  public filterMonth = "";
  public topState: any[] = [];
  shiftRemainingTime = "00:00:00";
  percentageInProgress = 100;
  checkInArrayForGraph: any[] = [];
  checkOutArrayForGraph: any[] = [];
  checkInChartData: any = {};
  checkOutChartData: any = {};
  checkInData: any[] = [];
  checkOutData: any[] = [];
  isPrintPage = false;
  printingContent: any = {};
  checkInDays: any[] = [];
  checkOutDays: any[] = [];
  secondShitEmployees = [46, 55, 60, 63, 61, 73, 112];
  checkOutDate: any;
  totalHours = 0;
  checkOutTime = "";
  checkInDate: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;
  refresh: any;
  latitude = 0;
  longitude = 0;
  errorMessage: string | null = null;
  org_lat: any;
  org_long: any;
  deviceUuid: any;
  att_shift_start_time: any;
  att_shift_end_time: any;
  att_total_hours: any;
  multiple_push: any;
  initialTime: any;
  latest_start_time: any;
  latest_end_time: any;
  user_shift_start_time: any;
  user_shift_end_time: any;
  user_total_hours: any;
  latest_total_hours: any;

  user_role: any;
  roleType: any;
  attendanceData: any;
  rangeData: any;
  remaininghours: any;
  remainingminutes: any;
  remaininseconds: any;
  runningTimer: any;
  lat = 0;
  long = 0;
  theme_id: any;
  aniversarydays: any;
  unpaid_leave: any;
  total_leaves: any;
  birthday: any;
  aniversaryhours: any;
  aniversaryminutes: any;
  aniversaryseconds: any;
  previousAnniversaryDays: any;
  anniversary_count: string | undefined;
  years_count: any;
  totalDaysforWorkingHours: any;
  totalLeaves: any;
  totalAbsent: any;
  overtimeDays: any;
  totalCheckInMissed: any;
  totalCheckOutMissed: any;
  shorthoursDays: any;
  workingHoursNew: any;
  private isFetchingUserDetail = false;
  userWorkingHours: any;
  mediaObject: any[] = [];
  isNewsUpdateShow = false;
  user_evalutaion: any;
  evaluation: any;
  percentageevaluation: any;

  workingHoursTotalAssignMonth: any;
  workingHoursTotalAssignMonth_totalDays: any;
  startdateforfilter: string | null;

  hasDoubleAttendance = false;
  doubleAttendanceRecords: any[] = [];
  bulkOvertimeReason = '';

  constructor(
    private attendanceService: AttendanceService,
    private leaveService: LeaveService,
    public router: Router,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,
    private deviceUuidService: DeviceUuidService,
    private _location: Location,
    public datepipe: DatePipe,
    private renderer: Renderer2,
    private oneSignal: OneSignal,
    private http: HttpClient,
  ) {
    const date = new Date();
    this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
    this.startdateforfilter = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() - 1, 1), 'yyyy-MM-dd');

    this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_role = JSON.parse(this.user.user_role.user_roles)
    this.roleType = this.user_role?.role_type;
    // if (this.roleType == 'Admin' || this.roleType == 'Employee' || this.roleType == 'Admin_AND_Team_Lead') {
    //   this.router.navigate(['/user-attendance']);
    // }

  }

  ngOnInit(): void {
    // this.getLocation();
    this.deviceUuid = localStorage.getItem("userDeviceID_OneSignal_subcripptio")
    this.runningTimer = setInterval(() => { this.Running() }, 1000);
    const date = new Date();
    this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
    this.startdateforfilter = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() - 1, 1), 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    // $('.attendance-d a').removeClass('active');
    // $(this).addClass('active');

    // $('.circle_animation').css('stroke-dashoffset', 1);
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });

    this.user_detail();
    this.initializeData();
    this.getAttendanceStats();
    this.getLeaves();

    this.getAttendanceData();
    this.isSecondShiftEmployee();
    this.user_refresh();
    this.checkTimer();

  }


  // totalWorkingHoursCal: number = 0;

  // updateTotalData(receivedValue: number) {
  //   this.totalWorkingHoursCal += receivedValue; // Accumulate working hours from children
  // }

  getImageURL(latitude: number, longitude: number): any {
    if ((latitude ?? 0) == 0 || (longitude ?? 0) == 0) {
      return '../../../../assets/images/no_Location.png'
    } else {
      return `https://maps.google.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=17&size=640x480&scale=4&markers=size:large%7Ccolor:orange%7C${latitude},${longitude}&key=${environment.GoogleMapKey}`
    }
  }
  user_refresh() {
    this.dashboardService.getuserrefresh().then((value) => {
      this.refresh = value?.data?.user
      this.user = this.refresh;
      this.birthday = this.user.dob
      if (this.birthday) {
        const datePattern = /^\d{4}-\d{2}-\d{2}$/;
        if (datePattern.test(this.birthday)) {
          const date = new Date(this.birthday);
          const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'short' };  // Day and abbreviated month (e.g., "4 Aug")
          this.birthday = date.toLocaleDateString('en-GB', options); // Apply the formatting
        }
      }
      this.att_shift_start_time = this.user.shift_start_time;
      this.att_shift_end_time = this.user.shift_end_time;
      this.att_total_hours = this.user.total_working_hours || this.user.usershittime?.[0].total_working_hours
      this.org_lat = this.refresh?.organization?.address.latitude;
      this.org_long = this.refresh?.organization?.address.longitude
      localStorage.setItem('user', JSON.stringify(value?.data?.user));
      const test_user = localStorage.getItem("user");
      const user_role = JSON.parse(this.user.user_role.user_roles)
      this.multiple_push = this.user.multiple_punch
      // if (user_role?.role_type != "Admin") {
      //   this.router.navigate(['/user-dashboard']);
      // }

    })

  }



  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }


  convertIntoSeconds(time: any) {
    const parts = time.split(':');
    return parts[0] * 3600 + parts[1] * 60;
  }

  getCurrentPosition(): Promise<{ latitude: number, longitude: number }> {
    return new Promise((resolve, reject) => {

      if (navigator.geolocation) {

        navigator.geolocation.getCurrentPosition((position) => {
          const coords = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          };
          resolve(coords);
        }, (error) => {
          console.error('Geolocation error:', error);
          reject(error);
        });
      } else {
        reject(new Error('Geolocation is not supported by this browser.'));
      }
    });
  }

  isAvaialbaletoCheckin(): boolean {
    if (this.isWFHAllowed()) {
      const checkout_count = this.checkOutTime?.length ?? 0
      const checkin_count = this.checkInTime?.length ?? 0
      if ((checkin_count == 0) && (checkout_count == 0)) {
        return true;
      } else if ((checkin_count > 0) && (checkout_count > 0) && this.multiple_push == 'Yes') {
        return true;
      } else {
        return false;
      }
    }
    return false
  }

  isWFHAllowed(): boolean {
    const dayIndex = 0;
    if ((this.user.usershittime?.[dayIndex]?.work_from_home == '1' && this.user.tracker != 1) || (this.user.attandance_type != 'Normal' && this.user.tracker != 1)) {
      return true
    }
    return false
  }
  // shouldShowPunchInOutButton(): boolean {
  //   if (this.user.tracker != 1) {
  //     return true
  //   }
  //   return false
  // }
  isAvaialbaletoCheckOut(): boolean {
    if (this.isWFHAllowed()) {
      const checkin_count = this.checkInTime?.length ?? 0
      const checkout_count = this.checkOutTime?.length ?? 0
      if ((checkin_count > 0) && (checkout_count == 0)) {
        return true;
      } else {
        return false;
      }
    }
    return false
  }

  getCheckInDetail() {
    if (this.isAvaialbaletoCheckin()) {
      this.showSpinner = true
      this.getCurrentPosition().then((coords) => {
        this.showSpinner = false
        this.latitude = coords.latitude;
        this.longitude = coords.longitude;
        const currentDate = new Date();
        const mn = currentDate.getMonth() + 1
        const month = (mn < 10) ? `0${mn}` : (mn)
        const checkInTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes()}`;
        if (this.checkInDate == null || this.checkInDate == undefined || this.checkInDate == '') {
          this.checkInDate = `${currentDate.getFullYear()}/${month}/${currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate()}`;
        } else {
          this.checkInDate = this.checkInDate
        }

        Swal.fire({
          iconHtml: `    <div style="text-align: center;">
            <img
                style="width: 100% !important;"
                src="${this.getImageURL(this.latitude, this.longitude)}"
                alt="image"
                onerror="this.onerror=null;this.src='../../../../assets/images/Info_icon.svg';"
            >`,
          title: 'Do you really want to check In?',
          text: `Your Check In Time is  :  ${checkInTime} `,
          showCancelButton: true,
          confirmButtonText: "Yes, Check In",
          showConfirmButton: true,
          cancelButtonText: "Not Now"
        }).then((checkout: any) => {
          if (checkout.value) {

            const model = {

              date: this.checkInDate,
              check_in: checkInTime,
              latitude: this.latitude,
              longitude: this.longitude,
              org_lat: this.org_lat,
              org_long: this.org_long,
              // device_id: "D3FE1439-321A-4025-B864-EEA89DDC9EF" ,
              device_id: this.deviceUuid,
              location: "Lahore",
              is_portal: 1,
              user_id: this.user.id,
              attendance_type_id: 4,
              lunch_id: 1,
              source: "web_portal",

            };
            this.checkIn(model);
            this.showSpinner = false;

          }
        });
      }).catch((error) => {
        this.showSpinner = false
        this.errorMessage = error.message;
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
          title: `We are not able to get your Current Location, please try again!`,
          showConfirmButton: false,
          timer: 2000,
        })
      });
    } else {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
        title: `Check In Already Applied First do Check Out `,
        showConfirmButton: false,
        timer: 2000,
      })
    }
  }


  getCheckOutDetail() {
    this.showSpinner = true;
    this.dashboardService.getTodayCheckIn().then((value) => {
      this.showSpinner = false
      this.checkInDate = value?.data?.date;
      this.checkInTime = value?.data?.check_in;
      this.checkOutTime = value?.data?.check_out;
      if (this.isAvaialbaletoCheckOut()) {

        this.getCurrentPosition().then((coords) => {
          this.showSpinner = false;
          if (coords) {
            this.latitude = coords.latitude;
            this.longitude = coords.longitude;
          } else {
            // If no location, set default or empty
            this.latitude = 0;
            this.longitude = 0;
          }
          // this.latitude = coords.latitude;
          // this.longitude = coords.longitude;
          const currentDate = new Date();
          const mn = currentDate.getMonth() + 1
          const month = (mn < 10) ? `0${mn}` : (mn)
          const checkOutTime = `${currentDate.getHours()}:${currentDate.getMinutes() < 10 ? "0" + currentDate.getMinutes() : currentDate.getMinutes()}`;
          this.checkOutDate = `${currentDate.getFullYear()}/${month}/${currentDate.getDate() < 10 ? "0" + currentDate.getDate() : currentDate.getDate()}`;
          if (this.checkInTime != "") {
            this.totalHours = Math.abs(new Date(`${this.checkOutDate} ${checkOutTime}`).getTime() - new Date(`${this.checkInDate} ${this.checkInTime}`).getTime()) / 36e5;
            this.totalHours = this.totalHours < 0 ? this.totalHours * (-1) : this.totalHours;
          }
          Swal.fire({
            // iconHtml: ` <img style='width: 100% !important;' src=${this.getImageURL(this.latitude, this.longitude)}  alt="image" onerror="this.onerror=null;this.src='../../../../assets/images/Info_icon.svg'; >`,
            iconHtml: `    <div style="text-align: center;">
            <img
                style="width: 100% !important;"
                src="${this.getImageURL(this.latitude, this.longitude)}"
                alt="image"
                onerror="this.onerror=null;this.src='../../../../assets/images/Info_icon.svg';"
            >`,
            title: 'Do you really want to check out?',
            text: `Your Check Out Time is  :  ${checkOutTime} `,
            showCancelButton: true,
            confirmButtonText: "Yes, Check Out",
            showConfirmButton: true,
            cancelButtonText: "Not Now"
          }).then((checkout: any) => {
            if (checkout.value) {
              const model = {
                date: this.checkInDate,
                check_out: checkOutTime,
                check_in: "",
                total_hours: this.totalHours != 0 ? this.totalHours.toFixed(2) : 0,
                latitude: this.latitude,
                longitude: this.longitude,
                org_lat: this.org_lat,
                org_long: this.org_long,
                // device_id: "D3FE1439-321A-4025-B864-EEA89DDC9EF",
                device_id: this.deviceUuid,
                location: "Lahore",
                is_portal: 1,
                user_id: this.user.id,
                attendance_type_id: 4,
                lunch_id: 1,
                source: "web_portal",
              };
              this.checkOut(model);
            }
            else if (checkout.value == false) {
              Swal.fire({
                iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
                title: `You Are Not in Range`,
                showConfirmButton: false,
                timer: 2000,
              })
            }
          });
        }).catch((error) => {
          this.showSpinner = false
          Swal.fire({
            iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
            title: `We are not able to get your Current Location, please try again!`,
            showConfirmButton: false,
            timer: 2000,
          })
        });
      }
      else {
        this.showSpinner = false
        Swal.fire({
          iconHtml: ' <img src="../../../../assets/images/Info_icon.svg"  alt="image" >',
          title: `You are not allowed to check out at this moment, Please Check In First, Thanks.`,
          showConfirmButton: false,
          timer: 2000,
        })
      }
    })
  }

  checkOut(model: any) {
    this.showSpinner = true
    this.dashboardService.checkOutFromPortal(model).then((result) => {
      if (result.success) {
        this.showSpinner = false
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: result.message,
          showConfirmButton: false,
          timer: 2000,
        })
        this.showSpinner = false
        // window.location.reload();
      }
      else {
        Swal.fire({
          iconHtml: '<img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: result.message,
          showConfirmButton: false,
          timer: 2000,
        })
        this.showSpinner = false
      }
         this.user_detail();
    this.initializeData();
    this.getAttendanceStats();
    this.getLeaves();

    this.getAttendanceData();
    this.isSecondShiftEmployee();
    this.user_refresh();
    this.checkTimer();
      
    });
  }

  checkIn(model: any) {
    this.showSpinner = true
    this.dashboardService.checkInFromPortal(model).then((result) => {
      if (result.success) {
        this.showSpinner = false
        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/success-modal.svg"  alt="image" >',
          title: result.message,
          showConfirmButton: false,
          timer: 2000,
        })
        this.showSpinner = false
        // window.location.reload();
      } else {

        Swal.fire({
          iconHtml: ' <img style="width="240"; height="240" src="../../../../assets/images/modal-close.svg"  alt="image" >',
          title: result.message,
          showConfirmButton: false,
          timer: 2000,

        })
        this.showSpinner = false
        // window.location.reload();

      }
       this.user_detail();
    this.initializeData();
    this.getAttendanceStats();
    this.getLeaves();

    this.getAttendanceData();
    this.isSecondShiftEmployee();
    this.user_refresh();
    this.checkTimer();
      
    });
  }
  countdownTimeStart(time: string) {
    if (time != null && time != "" && time != undefined && (this.checkOutTime == "" || this.checkOutTime == null)) {
      this.runningTimer = setInterval(() => {
        // Get the current time
        const currentDate = new Date();

        // Parse the provided start time
        const month = currentDate.toLocaleString('default', { month: 'short' });
        const startTime = new Date(`${month} ${currentDate.getDate()} ${currentDate.getFullYear()} ${time}`);

        // Calculate the elapsed time in milliseconds
        const elapsed = currentDate.getTime() - startTime.getTime();

        if (elapsed >= 0) {
          // Dynamic allowed time (in milliseconds)
          const maxAllowedTime = this.userWorkingHours * 60 * 60 * 1000;

          // Stop the timer when the dynamic time limit is reached
          if (elapsed >= maxAllowedTime) {
            clearInterval(this.runningTimer);
            this.shiftRemainingTime = `${this.userWorkingHours.toString().padStart(2, '0')}:00:00`;
            this.percentageInProgress = 100; // Lock at 100%
            return;
          }
          // Convert elapsed time to hours, minutes, and seconds
          const hours = Math.floor((elapsed % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((elapsed % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((elapsed % (1000 * 60)) / 1000);

          // Format with leading zeros
          const secondsWithZero = seconds < 10 ? "0" + seconds : seconds;
          const minutesWithZero = minutes < 10 ? "0" + minutes : minutes;

          // Update elapsed time
          this.remaininghours = hours.toString();
          this.remainingminutes = minutesWithZero;
          this.remaininseconds = secondsWithZero;
          this.shiftRemainingTime = `${hours}:${minutesWithZero}:${secondsWithZero}`;

          // Calculate progress percentage
          const totalElapsedSeconds = hours * 3600 + minutes * 60 + seconds;
          const maxShiftSeconds = this.userWorkingHours * 3600;
          const percentage = (totalElapsedSeconds / maxShiftSeconds) * 100;
          // Update progress percentage (capped at 100%)
          this.percentageInProgress = Math.min(+percentage.toFixed(2), 100);
       
        }
      }, 1000);
    } else {
      this.shiftRemainingTime = "00:00:00";
    }
  }

  getData() {
    this.showSpinner = true;
    this.attendanceService.getAttendance(
      this.startdate?.replace(new RegExp('-', 'g'), '/'),
      this.endDate?.replace(new RegExp('-', 'g'), '/'),
      null,
      null
    ).then((value) => {
      
      this.typeArr = value?.data?.attendance
      this.workingHours = value?.data?.total_hours;
      this.overtime = value?.data?.overtime;
      this.applyDataonAttandace();
      const temp_array: any[] = []
      let indexCount = 0
      let lastDate = ""
      let totalHours = 0
      let singleArray: any[] = []
      value.data.attendance.forEach((x: any) => {
        if (indexCount == 0) {
          totalHours += x.total_hours ?? 0
          lastDate = x.date
          singleArray.push(x)
          if (indexCount == this.typeArr.length - 1) {
            var obj = { "total_hours": totalHours ?? 0, "data": singleArray }
            temp_array.push(obj)
          }
        } else {
          if (x.date == lastDate) {
            totalHours += x.total_hours ?? 0
            singleArray.push(x)
            if (indexCount == this.typeArr.length - 1) {
              var obj = { "total_hours": totalHours ?? 0, "data": singleArray }
              temp_array.push(obj)
            }
          } else {
            var obj = { "total_hours": totalHours ?? 0, "data": singleArray }
            temp_array.push(obj)
            singleArray = []
            lastDate = x.date
            totalHours = 0
            totalHours = x.total_hours ?? 0
            singleArray.push(x)
            if (indexCount == this.typeArr.length - 1) {
              var obj = { "total_hours": totalHours ?? 0, "data": singleArray }
              temp_array.push(obj)
            }
          }
        }

        indexCount++

        if (x.check_in != "" && x.check_in != null) {
          this.checkInDays.push(new Date(x.date).getDate().toString());
          if (this.user?.attandance_type == "BD_Open") {
            if (x?.check_in > "21:00") {
              this.checkInArrayForGraph.push("21:00");
            } else {
              this.checkInArrayForGraph.push(x?.check_in);
            }
          } else {
            if (x?.check_in > "11:00") {
              this.checkInArrayForGraph.push("11:00");
            } else {
              this.checkInArrayForGraph.push(x?.check_in);
            }
          }
        }
        if (x.check_out != "" && x.check_out != null) {
          this.checkOutDays.push(new Date(x.date).getDate().toString());
          if (x.check_out > "21:00") {
            this.checkOutArrayForGraph.push("21:00");
          }
          else {
            this.checkOutArrayForGraph.push(x?.check_out);
          }
        }
      });

      this.typeArr = temp_array;
      this.checkDoubleAttendance();
      this.showSpinner = false;
    });
  }

  checkDoubleAttendance() {
    this.doubleAttendanceRecords = [];
    this.typeArr.forEach((item: any) => {
      // Exclude if already applied for overtime or any correction on this day
      // Check if ANY record for this day has a valid request_status
      const alreadyApplied = item.data.some((r: any) => r.request_status && r.request_status.trim() !== '');
      if (alreadyApplied) return;

      const first = item.data[0];
      
      // Get shift total hours for this day
      let expectedHours = Number(first.total_working_hours ?? first?.usershittime?.total_working_hours ?? this.user.usershittime?.[0]?.total_working_hours ?? 0);
      
      // Ramzan logic
      const recordDate = new Date(first.date.replace(/\//g, "-"));
      const ramzanDateStart = new Date("2026/02/19");
      const ramzanDateEnd = new Date("2026/03/20");
      if (recordDate > ramzanDateStart && recordDate < ramzanDateEnd && expectedHours > 7) {
        expectedHours = 7.0;
      }

      const firstTotalHours = Number(first.total_hours ?? 0);
      const isOffDay = first.off_day == 1 || first?.usershittime?.off_day == '1' || first?.usershittime?.off_day == 1;

      // Rule 1: Double attendance, first record full, second is Tracker
      if (item.data.length > 1) {
        const second = item.data[1];
        if (firstTotalHours >= expectedHours && second.source === 'Tracker') {
          this.doubleAttendanceRecords.push({
            ...item,
            overtime_hours: second.total_hours.toFixed(2),
            date: first.date,
            check_in: second.check_in,
            check_out: second.check_out,
            user_id: first.user_id,
            attendance_id: first.id, // Use first record ID instead of second
            source: second.source
          });
          return; // Already added this day
        }
      
      }

      // Rule 2: Off day and work with Tracker (can be 1 or more records)
      if (isOffDay) {
        const trackerRecord = item.data.find((r: any) => r.source === 'Tracker');
        if (trackerRecord) {
          this.doubleAttendanceRecords.push({
            ...item,
            overtime_hours: trackerRecord.total_hours.toFixed(2),
            date: trackerRecord.date,
            check_in: trackerRecord.check_in,
            check_out: trackerRecord.check_out,
            user_id: trackerRecord.user_id,
            attendance_id: trackerRecord.id,
            source: trackerRecord.source
          });
        }
      }
    });
    this.hasDoubleAttendance = this.doubleAttendanceRecords.length > 0;
  }

  applyBulkOvertime() {
    debugger
    if (this.bulkOvertimeReason.trim().length < 50) {
      Swal.fire({
        icon: 'error',
        title: 'Detail Required',
        text: 'Ensure that the entered Detail contains minimum of 50 characters.'
      });
      return;
    }

    this.showSpinner = true;
    const promises = this.doubleAttendanceRecords.map(record => {
      return this.attendanceService.attendanceCorrection(
        record.user_id,
        record.attendance_id,
        record.check_in,
        record.check_out,
        '', // working_hours
        record.overtime_hours,
        'overtime',
        record.date,
        this.bulkOvertimeReason,
        'pending',
        '' // old_value
      );
    });

    Promise.all(promises).then((results: any[]) => {
      this.showSpinner = false;
      const success = results.every(res => res.success);
      if (success) {
        ($('#bulkOvertimeModal') as any).modal('hide');
        Swal.fire({
          icon: 'success',
          title: 'Applied Successfully',
          text: 'Overtime requests have been submitted for all double attendance days.'
        }).then(() => window.location.reload());
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Some requests failed to submit.'
        });
      }
    }).catch(err => {
      this.showSpinner = false;
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An unexpected error occurred.'
      });
    });
  }

  calculateBulkOvertime(record: any) {
    if (record.check_in && record.check_out) {
      const startTime = new Date(`1970-01-01T${record.check_in}`);
      const endTime = new Date(`1970-01-01T${record.check_out}`);
      if (endTime <= startTime) {
        endTime.setDate(endTime.getDate() + 1);
      }
      const diff = (endTime.getTime() - startTime.getTime()) / (1000 * 60 * 60);
      record.overtime_hours = diff.toFixed(2);
    }
  }

  applyDataonAttandace() {
    // this.showSpinner = true;
    this.stats[0].worked_time = 0;
    this.workingHours = 0;
    this.stats[0].total_short_time = 0;
    this.stats[0].check_in_missed = 0;
    this.stats[0].check_in_late = 0;
    this.overtime = 0
    this.totalLeaves = 0;
    this.totalDaysforWorkingHours = 0;
    this.totalAbsent = 0;
    this.overtimeDays = 0;
    this.totalCheckInMissed = 0;
    this.totalCheckOutMissed = 0;
    this.shorthoursDays = 0;
    this.workingHoursNew = 0;
    this.workingHoursTotalAssignMonth = 0;
    this.workingHoursTotalAssignMonth_totalDays = 0;
    const processedDates = new Set();

    this.typeArr.forEach((x: any) => {
      const checkin = x?.check_in ?? ''
      const checkout = x?.check_out ?? ''
      const workingHours = parseFloat(x?.total_hours ?? 0);
      const worked_Hours = workingHours;
      this.stats[0].worked_time += worked_Hours;
      // this.workingHoursNew += x?.total_working_hours ?? 0
      const date = x?.date
      const leaveCheckDate = date?.replace(new RegExp('/', 'g'), '-')
      const dateOBJ = new Date(date);
      //overtime
      if (x?.overtime != 0 && x?.overtime > 0) {
        this.overtime += x?.overtime;
        this.overtimeDays += 1;
      }
      //total working hours and total working days
      if (!processedDates.has(date)) {
        processedDates.add(date);
        if (x?.usershittime?.off_day == '0' && x?.usershittime?.total_working_hours > 0 && !(this.dashboardService?.otherOffDays.includes(date))) {

          // total working hours and days
          const totalWorkingHoursPerDayAssign = parseFloat(x?.usershittime?.total_working_hours);
          this.workingHoursTotalAssignMonth += totalWorkingHoursPerDayAssign;
          this.workingHoursTotalAssignMonth_totalDays += 1;
          // this.totalAbsent += 1;
        }
        const attendance_shift_start = x.shift_start_time;
        if (attendance_shift_start == null) {
          this.initialTime = this.user?.shift_start_time;
        } else {
          this.initialTime = attendance_shift_start;
        }
        const startTimeLimit = calculateUpdatedTime(this.initialTime);

        if (checkin > startTimeLimit && !this.paidLeaves.includes(leaveCheckDate) && !this.unpaidLeaves.includes(leaveCheckDate)) {
          //Check In Late
          this.stats[0].check_in_late += this.dashboardService.getLateCheckInTime(checkin, this.user.id);
          this.totalCheckOutMissed += 1;
        }
      }
      if (this.user?.last_working_date < leaveCheckDate) {
        // Off Day (User Left Job)
      } else if (this.user?.joining_date > leaveCheckDate) {
        // Off Day (Before Joining)
      } else if (checkin?.length == 0
        && checkout?.length == 0
        && this.dashboardService?.otherOffDays.includes(date)) {
        // OFF DAY
      } else if (dateOBJ?.getDay() == 0 && checkin?.length == 0 && checkout?.length == 0) {
        //  OFF DAY (Sunday)
      } else if (dateOBJ?.getDay() == 6
        && checkin?.length == 0
        && checkout?.length == 0
        && !this.dashboardService.workingSaturdays.includes(date)) {
        //  OFF DAY (Saturday)
      }
      //  else if (dateOBJ?.getDay() == 6
      //   && checkin?.length == 0
      //   && checkout?.length == 0
      //   && this.dashboardService?.workingSaturdays.includes(date)
      //   && this.user.id == 54) {
      //   //  OFF DAY (Saturday) Farhan (Just need to add extra id check for othhers )
      // }
      else if (this.paidLeaves.includes(leaveCheckDate)) {
        //  Paid Leave (Approved)
        this.totalLeaves += 1;
      } else if (this.unpaidLeaves.includes(leaveCheckDate)) {
        //  Un Paid Leave (Approved)
        this.totalLeaves += 1;
      } else if(this.pendingLeaves.includes(leaveCheckDate)){
         this.totalLeaves += 1;
      } else if (checkin.length == 0 && checkout.length == 0) {
        // Absent
        this.totalAbsent += 1;
      }
      else {
        // asigning total hours
        // need to get from x attendance obj
        const attendance_total_hours = x.total_working_hours;
        const attendance_shift_end = x.shift_end_time;
        let perDayWorkingHour = this.user?.total_working_hours ?? 0;
        if (attendance_total_hours == null) {
          perDayWorkingHour = this.user?.total_working_hours ?? 0;
        } else {
          perDayWorkingHour = attendance_total_hours ?? 0
        }
        this.workingHours += parseFloat(perDayWorkingHour);
        this.totalDaysforWorkingHours = (this.totalDaysforWorkingHours ?? 0) + 1;

        if (checkin?.length == 0) {
          //Check in Miss
          this.stats[0].check_in_missed += 1;
          this.totalCheckInMissed += 1;
        }
        if (checkout?.length == 0) {
          //Check Out Miss
        }
        const perDayHours = parseFloat(perDayWorkingHour) || 0;
        if (workingHours > 0 && workingHours < perDayHours) {
          //Short Time
          const shrtH = Number((perDayHours - workingHours).toFixed(2));
          this.stats[0].total_short_time += shrtH;
          this.shorthoursDays += 1;
        }



      }
    });

    if (this.filterType.length > 0) {
      this.applyTypefilter(this.filterType);
    }
  }
  applyTypefilter(filter: string) {
    const tmp_typeArr: any = [];
    this.typeArr.forEach((x: any) => {
      debugger
      const checkin = x?.check_in ?? ''
      const checkout = x?.check_out ?? ''
      const workingHours = x?.total_hours ?? 0
      const date = x?.date
      const leaveCheckDate = date.replace(new RegExp('/', 'g'), '-')
      const dateOBJ = new Date(date);
      switch (filter) {
        case "Sunday":
          if (dateOBJ.getDay() == 0 && checkin?.length == 0 && checkout?.length == 0) {
            tmp_typeArr.push(x)
          }
          break;
        case "Saturday":
          if (dateOBJ.getDay() == 6
            && checkin?.length == 0
            && checkout?.length == 0
            && !this.dashboardService.workingSaturdays.includes(date)) {
            //  OFF DAY (Saturday)
            tmp_typeArr.push(x)
          }
          break;
        case "Paid Leave":
          if (this.paidLeaves.includes(leaveCheckDate)) {
            tmp_typeArr.push(x)
          }
          break;
        case "Unpaid Leave":
          if (this.unpaidLeaves.includes(leaveCheckDate)) {
            tmp_typeArr.push(x)
          }
          break;
           case "Pending Leave":
          if (this.pendingLeaves.includes(leaveCheckDate)) {
            tmp_typeArr.push(x)
          }
          break;
        case "Absent":
          if (checkin?.length == 0 && checkout?.length == 0
            && !this.unpaidLeaves.includes(leaveCheckDate)
            && !this.paidLeaves.includes(leaveCheckDate)
            && (!this.dashboardService.workingSaturdays.includes(date) && dateOBJ.getDay() != 6)
            && (dateOBJ.getDay() != 0)) {
            tmp_typeArr.push(x)
          }
          break;
        case "Check in Miss":
          if (checkin?.length == 0) {
            tmp_typeArr.push(x)
          }
          break;
        case "Check Out Miss":
          if (checkout?.length == 0) {
            tmp_typeArr.push(x)
          }
          break;
        case "Short Time":
          if (workingHours > 0 && workingHours < 9) {
            tmp_typeArr.push(x)
          }
          break;
        case "Check In Late":
          if (this.user?.attandance_type != "BD_Open") {
            const initialTime = this.user?.shift_start_time;
            const startTimeLimit = calculateUpdatedTime(initialTime);
            if (checkin > startTimeLimit) {
              tmp_typeArr.push(x)
            }
          }
          break;
      }
    });

    this.typeArr = tmp_typeArr;
  }

  onSubmit(f: NgForm) {
    this.showSpinner = true;
    if (f?.value?.startdate != null && f?.value?.startdate?.length > 0) {
      this.startdate = f?.value?.startdate
    }

    if (f?.value?.enddate != null && f?.value?.enddate?.length > 0) {
      this.endDate = f?.value?.enddate;
    }

    if (f?.value?.attendancetype != null && f?.value?.attendancetype?.length > 0) {
      this.filterType = f?.value?.attendancetype
      if (this.filterType == "LastMonth") {
        var date = new Date();
        this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() - 1, 1), 'yyyy-MM-dd');
        this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 0), 'yyyy-MM-dd');
        this.filterType = ""
      } else if (this.filterType == "ThisMonth") {
        var date = new Date();
        this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
        this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
        this.filterType = ""
      }
    }


    this.getLeaves();
  }

  onReset(f: NgForm) {
    this.showSpinner = true;
    f.reset();
    const date = new Date();
    this.startdate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth(), 1), 'yyyy-MM-dd');
    this.endDate = this.datepipe.transform(new Date(date.getFullYear(), date.getMonth() + 1, 0), 'yyyy-MM-dd');
    this.filterType = ""
    this.getLeaves();
  }
  calculateDiff(data_1: any, data_2: any) {
    const date1 = new Date(data_1);
    const date2 = new Date(data_2);

    const days = Math.floor(
      (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
    );
    return days + 1;
  }
  getLeaves() {
    this.showSpinner = true;
    this.leaveService.getLeaveFilter(
      this.startdateforfilter,
      this.endDate,
      null,
      null
    ).then((value) => {
      this.leaves = value?.data;
      debugger
      this.leaves.forEach(x => {
        if (x?.leave_type_id != 3) {
          if (x?.status == "approved") {
            debugger
            if (x?.leave_payment_status == "paid") {
              if ((x?.start_date != null || x?.start_date?.length > 0) && (x?.end_date != null || x?.end_date?.length > 0)) {
                var dtt = new Date(x?.start_date)
                var day = dtt.getDate()
                var totalDays = this.calculateDiff(x?.start_date, x?.end_date)
                for (let i = 0; i < totalDays; i++) {
                  var str = this.datepipe.transform(dtt.setDate(day + i), 'yyyy-MM-dd')
                  this.paidLeaves.push(str)
                }
              } else {

                this.paidLeaves.push(x?.start_date)
              }
            }
            else if (x?.leave_payment_status == "unpaid") {
              if ((x?.start_date != null || x?.start_date?.length > 0) && (x?.end_date != null || x?.end_date?.length > 0)) {
                var dtt = new Date(x?.start_date)
                var day = dtt.getDate()
                var totalDays = this.calculateDiff(x?.start_date, x?.end_date)
                for (let i = 0; i < totalDays; i++) {
                  var str = this.datepipe.transform(dtt.setDate(day + i), 'yyyy-MM-dd')
                  this.unpaidLeaves.push(str)
                }
              } else {
                this.unpaidLeaves.push(x?.start_date)
              }

            }
          } else {
            if (x?.leave_payment_status == "paid" || x?.leave_payment_status == "unpaid") {
              if ((x?.start_date != null || x?.start_date?.length > 0) && (x?.end_date != null || x?.end_date?.length > 0)) {
                var dtt = new Date(x?.start_date)
                var day = dtt.getDate()
                var totalDays = this.calculateDiff(x?.start_date, x?.end_date)
                for (let i = 0; i < totalDays; i++) {
                  var str = this.datepipe.transform(dtt.setDate(day + i), 'yyyy-MM-dd')
                  this.pendingLeaves.push(str)
                }
              } else {
                this.pendingLeaves.push(x?.start_date)
              }
            }
          }
        }

        // Add to shortLeaves for precise hour calculation in children
        if (x?.leave_type_id == 3) {
          this.shortLeaves.push({
            date: x.start_date.replace(/\//g, '-'),
            hours: parseFloat(x.shortLeave_hours || x.short_leave || 0),
            status: x.status,
            payment_status: x.leave_payment_status
          });
        }
        // this.showSpinner = false;

      });
      this.getData();
    });
  }
  getAttendanceStats() {
    // this.showSpinner = true;
    this.attendanceService.getStatsFilter().then((value) => {
      // alert("here");
      // this.showSpinner = false;
      this.stats = value?.data?.result;
      this.overtime = value?.data?.overtime;
      if (this.stats) {
        this.checkStats = true;
      }
    });
  }



  showCheckOutData() {
    const colors = [
      '#2180FF',
      '#2180FF',
      '#2180FF',
      '#2180FF',
      '#2180FF',
      '#2180FF',
    ];

    const checkOutData = this.checkOutDays.map((day, index) => ({
      y: moment(`1970-02-01 ${this.checkOutArrayForGraph[index]}`).valueOf()
    }));

    /* large line chart */
    this.checkOutChartData = {
      labels: this.checkOutDays,
      datasets: [
        {
          data: checkOutData,
          backgroundColor: 'rgba(33, 128, 255, 0.5)',
          borderColor: colors[1],
          borderWidth: 4,
          pointBackgroundColor: colors[1],
          fill: true
        },
      ],
    };
    const chLine = document.getElementById('chLine');
    if (chLine) {
      new Chart('chLine', {
        type: 'line',
        data: this.checkOutChartData,
        options: {
          maintainAspectRatio: false,
          scales: {
            yAxes: [
              {
                type: 'linear',
                position: 'left',
                ticks: {
                  min: moment('1970-02-01 18:00:00').valueOf(),
                  max: moment('1970-02-01 21:00:00').valueOf(),
                  stepSize: 3.6e+6,
                  beginAtZero: false,
                  callback: value => {
                    const date = moment(value);
                    if (date.diff(moment('1970-02-01 23:59:59'), 'minutes') === 0) {
                      return null;
                    }
                    return date.format('h A');
                  }
                }
              }
            ]
          },
          legend: {
            display: false,
          },
        },
      });
    }
  }


  // punchin and graph new start
  // top card end
  Running() {
    const countDownDate = new Date(this.user?.joining_date).getTime();

    this.anniversary_count = "1st"
    // Get today's date and time
    const now = new Date().getTime();
    let distance = now - countDownDate;
    distance = Math.abs(distance);
    let years_day = Math.floor(distance / (1000 * 60 * 60 * 24))
    years_day = Math.abs(years_day);
    // alert(years_day)
    if (years_day >= 365) {
      this.years_count = Math.floor(years_day / 365);
      years_day = years_day - (365.2 * this.years_count)
      years_day = 365 - years_day;
      years_day = Math.floor(years_day)
      years_day = Math.abs(years_day);
    } else {
      years_day = 365 - years_day;
      years_day = Math.floor(years_day)
      years_day = Math.abs(years_day);
    }
    this.aniversarydays = (years_day).toString();
    this.aniversaryhours = (24 - Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).toString();
    this.aniversaryminutes = (60 - Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).toString();
    this.aniversaryseconds = (60 - Math.floor((distance % (1000 * 60)) / 1000)).toString();
    if (this.aniversarydays !== this.previousAnniversaryDays) {
      // Update the chart if the value has changed
      this.initializeProgressChart();
      // Update the previous anniversary days value
      this.previousAnniversaryDays = this.aniversarydays;
    }


    if (this.years_count === 1) {
      this.anniversary_count = "2nd"
    } else if (this.years_count === 2) {
      this.anniversary_count = "3rd"
    } else if (this.years_count > 2) {
      this.anniversary_count = this.years_count + "th"
    }

  }
  checkTimer() {
    // this.showSpinner = true;
    this.dashboardService.getTodayCheckIn().then((value) => {
      // this.showSpinner = false;
      const userID = this.user?.id ?? "15500"
      this.oneSignal.login(String(userID)).then(value => {
      })

      if (localStorage.getItem('userDeviceID_OneSignal_subcripptio') == "" || localStorage.getItem('userDeviceID_OneSignal_subcripptio') == null) {
        //Get ID for Onesignla External ID
        const userID = this.user?.id ?? "15500"
        this.oneSignal.login(String(userID)).then(value => {
          const userDeviceID_OneSignal_subcripptio = this.oneSignal.User.PushSubscription.id ?? ""
          if (userDeviceID_OneSignal_subcripptio.length > 5) {
            this.deviceUuid = userDeviceID_OneSignal_subcripptio
            localStorage.setItem('userDeviceID_OneSignal_subcripptio', userDeviceID_OneSignal_subcripptio);
          }
        })
        const userDeviceID_OneSignal_subcripptio = this.oneSignal.User.PushSubscription.id ?? ""
        if (userDeviceID_OneSignal_subcripptio.length > 5) {
          this.deviceUuid = userDeviceID_OneSignal_subcripptio
          localStorage.setItem('userDeviceID_OneSignal_subcripptio', userDeviceID_OneSignal_subcripptio);
        }
      } else {
        this.deviceUuid = localStorage.getItem('userDeviceID_OneSignal_subcripptio')
      }
      if (value?.data != null) {
      debugger

        this.checkInDate = value?.data?.date,
          this.checkInTime = value?.data?.check_in || '';
        this.checkOutTime = value?.data?.check_out || '';
        this.countdownTimeStart(this.checkInTime);

      }
      this.initializeProgressChart();

    });

  }
  private initializeData() {
    // Populate with initial data for 31 days
    for (let i = 1; i <= 31; i++) {
      const date = i.toString();
      this.categories.push(date);
      this.allData.push({
        date,
        values: [
          Math.floor(Math.random() * 100), // Data for Series 1
          Math.floor(Math.random() * 100), // Data for Series 2
          Math.floor(Math.random() * 100), // Data for Series 3
          Math.floor(Math.random() * 100)  // Data for Series 4
        ]
      });
    }
  }
  private initializeProgressChart(): void {
    const totalDays = 365;
    const currentDays = this.aniversarydays;
    const progressPercentage = (currentDays / totalDays) * 100;

    this.optionsProgress3 = {
      chart: {
        height: 70,
        type: "bar",
        stacked: true,
        sparkline: {
          enabled: true,
        },
      },
      plotOptions: {
        bar: {
          horizontal: true,
          barHeight: "20%",
          borderRadius: 6, // Apply border radius to the main bar
          colors: {
            backgroundBarColors: ["#f7f5f5"], // Background bar color
            backgroundBarRadius: 6, // Apply the same border radius to the background bar
          },
        },
      },
      colors: ["#1DBFC8"], // Solid bar color
      stroke: {
        width: 0,
      },
      series: [
        {
          name: "Process 3",
          data: [progressPercentage],
        },
      ],
      fill: {
        // type: "solid", // Use solid fill
        colors: ["#1DBFC8"], // Single solid color
      },
      tooltip: {
        enabled: false,
      },
      xaxis: {
        categories: ["Process 3"],
      },
      yaxis: {
        max: 100,
      },
    };
  }
  async user_detail() {
    if (this.isFetchingUserDetail) return;
    this.isFetchingUserDetail = true;
    // this.showSpinner = true;
    try {
      const value = await this.dashboardService.getuserdetail()
      this.userInfo = value?.data;
      this.colormode = this.userInfo?.color_mode;
      this.total_leaves = this.userInfo?.total_leaves;
      this.unpaid_leave = this.userInfo?.unpaid_leave;
      this.sharedmode.setMode(this.colormode);
      this.theme_id = this.userInfo?.theme_id;
      if (this.theme_id === 2) {
        this.renderer.addClass(document.body, 'dark-theme');
      } else {
        this.renderer.removeClass(document.body, 'dark-theme');
      }
    } finally {
      this.isFetchingUserDetail = false;
      // this.showSpinner = false;
    }

  }

  shouldShowPunchIn(): boolean {
    return !this.checkInTime || !!this.checkOutTime; // Determine if Punch In should show
  }

  shouldShowPunchOut(): boolean {
    return !!this.checkInTime && !this.checkOutTime; // Determine if Punch Out should show
  }

  isSecondShiftEmployee() {
    if (this.isWFHAllowed()) {
      return false
    }
    return true
  }




  getAttendanceData() {
    this.showSpinner = true;
    this.attendanceService.getAttendance(
      this.startdate?.replace(new RegExp('-', 'g'), '/'),
      this.endDate?.replace(new RegExp('-', 'g'), '/'),
      null,
      null
    ).then((value) => {
      this.attendanceData = value?.data?.attendance;
      this.rangeData = []; // Initialize array for range data

    this.attendanceData.forEach((x: any) => {
      const dayLabel = new Date(x?.date).getDate().toString();
      const totalHours = Number(x?.total_hours ?? 0); // Actual hours worked
      const expectedHours = Number(x?.usershittime?.total_working_hours ?? 9); // Expected hours
      const checkIn = x?.check_in;
      const checkOut = x?.check_out;

      // ✅ Show full bar (expected hours) for absentees
      const yValue =
        (checkIn == null && checkOut == null) || totalHours === 0
          ? expectedHours
          : totalHours;

      this.rangeData.push({
        x: `${dayLabel}`,
        y: yValue, // Bar height (full if absent)
      });
    });

    // ✅ Build chart options
    this.chartOptions = {
      series: [
        {
          name: 'Total Hours',
          data: this.rangeData,
        },
      ],
      chart: {
        height: 250,
        type: 'bar',
        toolbar: { show: false },
      },
      plotOptions: {
        bar: { horizontal: false, columnWidth: '60%' },
      },
      colors: [
        ({ dataPointIndex }: { dataPointIndex: number }) => {
          const entry = this.attendanceData[dataPointIndex];
          if (!entry) return '#FFBF42';

          const totalHours = Number(entry?.total_hours ?? 0);
          const expectedHours = Number(entry?.usershittime?.total_working_hours ?? 9);
          const overtime = Number(entry?.overtime ?? 0);
          const checkIn = entry?.check_in;
          const checkOut = entry?.check_out;

          // 🎨 Color logic
          if (overtime > 0) return '#DBC1E8'; // Purple - Overtime
          if (totalHours >= expectedHours && totalHours > 0) return '#CEEED9'; // Green - Full Day
          if ((checkIn == null && checkOut == null) || totalHours === 0) return '#F6CECE'; // 🔴 Red - Absent
          if (totalHours < expectedHours) return '#F6CECE'; // Red - Short Hours

          return '#FFBF42'; // Default fallback
        },
      ],
      grid: { show: false },
      xaxis: {
        title: {
          text: 'Days',
          style: { color: '#FF0000', fontSize: '14px' },
        },
        labels: {
          style: {
            colors: Array(this.rangeData.length).fill('#FF0000'),
            fontSize: '14px',
          },
        },
      },
      yaxis: {
        title: {
          text: 'Hours',
          style: { color: '#FF0000', fontSize: '14px' },
        },
        labels: {
          style: { colors: ['#FF0000'], fontSize: '14px' },
        },
      },
      tooltip: {
        y: {
          formatter: (val: number, opts: any) => {
            const entry = this.attendanceData[opts.dataPointIndex];
            const totalHours = Number(entry?.total_hours ?? 0);
            const checkIn = entry?.check_in;
            const checkOut = entry?.check_out;

            if ((checkIn == null && checkOut == null) || totalHours === 0) {
              return 'Absent';
            }
            return `${val} hours`;
          },
        },
      },
      dataLabels: { enabled: false },
    };
  });
    this.getData();
    this.getData2();


  }
  getData2() {
    this.dashboardService.getDashboardData().then((value) => {
      this.mediaObject = value?.media;
      if (value?.media != null && value?.media != undefined && value?.media?.length > 0) {
        this.isNewsUpdateShow = true;
      }
      this.user_evalutaion = value?.emp_evaluations;
      if (this.user_evalutaion?.length > 0) {
        const points = this.user_evalutaion[this.user_evalutaion?.length - 1]?.pm_points;
        this.evaluation = value?.emp_evaluations[0]?.pm_points
        this.percentageevaluation = Math.max(0, Math.min(100, (this.evaluation / 10) * 100));
        this.calculateEvaluationProgress(this.percentageevaluation);
      }

    });
  }
  calculateEvaluationProgress(evaluation: any) {

    this.pieChartOptions = {
      chart: {
        type: 'pie',
        height: 350
      },
      series: [evaluation, 100],
      colors: ['#CDCFFF', '#F9F9F9'],
      dataLabels: {
        enabled: false
      },
      legend: {
        show: false,
        position: 'bottom',
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
        }
      }]
    };
  }
  updateChartOptions(rangeData: any[]) {
    this.chartOptions = {
      series: [
        {
          name: 'Total Hours',
          data: rangeData,
        },
      ],
      chart: {
        height: 230,
        type: 'bar',
        toolbar: { show: false },
      },
      plotOptions: {
        bar: { horizontal: false, columnWidth: '60%' },
      },
      colors: [
        ({ dataPointIndex }: { dataPointIndex: number }) => {
          const entry = this.attendanceData[dataPointIndex];

          if (!entry) return '#FFBF42'; // Default color if no entry found
          const totalHours = entry.total_hours;
          const userWorkingHours = Number(entry.usershittime?.total_working_hours);
          const overtime = entry.overtime;

          // Logic for colors
          if (overtime > 0) {
            return '#DBC1E8'; // Purple for overtime
          }
          if (totalHours >= userWorkingHours) {
            return '#CEEED9'; // Green for "All Good"
          }

          if (totalHours == null) {
            return '#FFBF42'
          }
          if (totalHours < userWorkingHours) {
            return '#F6CECE'; // Red for "Short Time"
          }

          return '#FFBF42'; // Default fallback color
        },
      ],

      grid: { show: false },
      xaxis: {
        title: {
          text: 'Days',
          style: { color: '#FF0000', fontSize: '14px' },
        },
        labels: {
          style: { colors: Array(rangeData.length).fill('#FF0000'), fontSize: '14px' },
        },
      },
      yaxis: {
        title: {
          text: 'Hours',
          style: { color: '#FF0000', fontSize: '14px' },
        },
        labels: {
          style: { colors: ['#FF0000'], fontSize: '14px' },
        },
      },
      tooltip: {
        y: {
          formatter: (val: number) => `${val} hours`,
        },
      },
      dataLabels: { enabled: false },
    };
  }


 filterBars(filterType: string) {
  const filteredData = this.attendanceData
    .map((x: any, index: number) => {
      const totalHours = Number(x?.total_hours ?? 0);
      const userWorkingHours = Number(x?.usershittime?.total_working_hours ?? 9);
      const overtime = Number(x?.overtime ?? 0);
      const hasCheckInOut = x?.check_in && x?.check_out;
      const isAbsent = (x?.check_in == null && x?.check_out == null) || totalHours === 0;

      let conditionMet = false;

      // ✅ Filter logic
      if (filterType === 'overtime' && overtime > 0 && hasCheckInOut) {
        conditionMet = true;
      } else if (filterType === 'shortTime' && userWorkingHours > totalHours && overtime === 0 && hasCheckInOut) {
        conditionMet = true;
      } else if (filterType === 'allGood' && totalHours >= userWorkingHours && overtime === 0 && hasCheckInOut) {
        conditionMet = true;
      } 
      // ✅ For “All”, include everyone — including absentees
      else if (filterType === 'all') {
        conditionMet = true;
      }

      if (conditionMet) {
        const dayLabel = new Date(x.date).getDate().toString();
        const yValue =
          filterType === 'all' && isAbsent
            ? userWorkingHours // Show full bar (9 hours) for absentees in "all"
            : totalHours;

        return {
          x: `${dayLabel}`,
          y: yValue,
          index,
          isAbsent,
        };
      }

      return null;
    })
    .filter((item: any) => item);

  // ✅ Update chart options
  this.chartOptions = {
    ...this.chartOptions,
    series: [
      {
        name: 'Total Hours',
        data: filteredData,
      },
    ],
    colors: [
      ({ dataPointIndex }: { dataPointIndex: number }) => {
        const dataPoint = filteredData[dataPointIndex];
        if (!dataPoint) return "#FFBF42";

        const entry = this.attendanceData[dataPoint.index];
        const totalHours = Number(entry?.total_hours ?? 0);
        const userWorkingHours = Number(entry?.usershittime?.total_working_hours ?? 9);
        const overtime = Number(entry?.overtime ?? 0);
        const isAbsent = (entry?.check_in == null && entry?.check_out == null) || totalHours === 0;

        // 🎨 Color logic
        if (filterType === 'all' && isAbsent) return "#F6CECE"; // 🔴 Red - Absent (only for “All”)
        if (overtime > 0) return "#DBC1E8"; // 🟪 Purple - Overtime
        if (totalHours >= userWorkingHours && totalHours > 0) return "#CEEED9"; // 🟩 Green - Full Day
        if (totalHours < userWorkingHours) return "#F6CECE"; // 🔴 Red - Short Time
        return "#FFBF42"; // 🟨 Default
      },
    ],
    tooltip: {
      y: {
        formatter: (val: number, opts: any) => {
          const dataPoint = filteredData[opts.dataPointIndex];
          const entry = this.attendanceData[dataPoint.index];
          const totalHours = Number(entry?.total_hours ?? 0);
          const isAbsent = (entry?.check_in == null && entry?.check_out == null) || totalHours === 0;

          if (filterType === 'all' && isAbsent) return "Absent";
          return `${val} hours`;
        },
      },
    },
  };
}


  //punchin and graph new end
Attendacereq(){
  this.router.navigate(['/attendance-requests'])
}




}
